<template>
  <transition v-bind="modalTransition">
    <div v-if="isOpen" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div class="mx-auto max-w-sm bg-white p-4 shadow-4">
        <h2 class="mb-4 text-xl font-semibold">Confirmar exclusão</h2>
        <p class="mb-4">
          Tem certeza que deseja excluir <strong>{{ itemName }}</strong>?
        </p>
        <div class="flex justify-end gap-2">
          <button type="button" @click="cancel" class="px-4 py-2 text-slate-500 hover:text-slate-400">
            Cancelar
          </button>
          <button
            type="button"
            @click="confirm"
            class="bg-red px-4 py-2 text-white hover:bg-rose-500">
            <span v-if="!isDeleting">Excluir</span>
            <ButtonLoader v-else />
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import ButtonLoader from '@/components/Globals/Feedbacks/ButtonLoader.vue'
import { modalTransition } from '@/plugins/transitions'

defineProps<{
  isOpen: boolean
  itemName: string
  isDeleting: boolean
}>()

const emit = defineEmits<{
  close: []
  confirm: []
}>()

function cancel() {
  emit('close')
}

function confirm() {
  emit('confirm')
}
</script>
